export default {
    "59": {
        "ID": 59,
        "InfoComment": "Dieses Konzert findet im Rahmen des \"Marsch des Lebens\" statt. Informationen unter <a href='http://marschdeslebens.org/'>marschdeslebens.org</a>. Reservierung unter <a href='mailto: uta.lang@kisi.at'>uta.lang@kisi.at</a>. Freiwillige Spende."
    },
    "68": {
        "ID": 68,
        "InfoComment": "Dieses Konzert ist eine Schulaufführung."
    },
    "69": {
        "ID": 69,
        "InfoComment": "Dieses Konzert ist eine Schulaufführung."
    },
    "87": {
        "ID": 87,
        "InfoComment": "Eintritt frei – freiwillige Spenden.<br>Das Musical wird von den KISIs aus Vorarlberg aufgeführt. Informationen zu KISI in Vorarlberg finden Sie unter <a href='http://www.kisivorarlberg.at' target='_blank'>kisivorarlberg.at</a>."
    },
    "88": {
        "ID": 88,
        "InfoComment": "Eintritt frei – freiwillige Spenden.<br>Das Musical wird von den KISIs aus Vorarlberg aufgeführt. Informationen zu KISI in Vorarlberg finden Sie unter <a href='http://www.kisivorarlberg.at' target='_blank'>kisivorarlberg.at</a>."
    },
    "89": {
        "ID": 89,
        "InfoComment": "Eintritt frei – freiwillige Spenden.<br>Das Musical wird von den KISIs aus Vorarlberg aufgeführt. Informationen zu KISI in Vorarlberg finden Sie unter <a href='http://www.kisivorarlberg.at' target='_blank'>kisivorarlberg.at</a>."
    }
}


// WEBPACK FOOTER //
// ./src/components/Content/Performances.js